export default "__VITE_ASSET__DY7VBU78__";